var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { Input, Label } from 'reactstrap';
import filterXSS from 'xss';
import { fixDecimal } from 'App/app/cart-logic';
import { currency, } from 'App/config';
import './savings-calculator.scss';
var portalPercents = [10, 11, 12, 13, 15, 16, 17, 18];
var orderAmountOptions = [20, 30, 50, 75, 100, 150, 200, 300, 400, 500];
var orderAvgPrices = [35, 40, 45, 50, 60, 70, 80, 90, 100];
var SavingsCalculator = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    var _c = __read(useState({
        portalCommissionPercent: 15,
        ordersMonthlyAmount: 100,
        avgOrderValue: 65,
    }), 2), values = _c[0], setValues = _c[1];
    useEffect(function () {
        var urlParams = new URLSearchParams(filterXSS(window.location.search));
        var valuesToUpdate = {};
        if (urlParams.has('commission')) {
            valuesToUpdate.portalCommissionPercent = parseFloat(urlParams.get('commission'));
        }
        if (urlParams.has('ordersAmount')) {
            valuesToUpdate.ordersMonthlyAmount = parseInt(urlParams.get('ordersAmount'), 10);
        }
        if (urlParams.has('orderAvg')) {
            valuesToUpdate.avgOrderValue = parseFloat(urlParams.get('orderAvg'));
        }
        if (Object.keys(valuesToUpdate).length > 0) {
            setValues(__assign(__assign({}, values), valuesToUpdate));
        }
    }, []);
    var handleChange = function (e) {
        var _a;
        var value = e.target.value;
        var parsedValue = value ? parseFloat(value) : '';
        setValues(__assign(__assign({}, values), (_a = {}, _a[e.target.name] = parsedValue, _a)));
    };
    var _d = calculateSavingsWithCommission(values), commissionWithPortal = _d.commissionWithPortal, commissionWithOwnWebsite = _d.commissionWithOwnWebsite, ordersCommission = _d.ordersCommission, onlinePaymentsCommission = _d.onlinePaymentsCommission, restaurantSavings = _d.restaurantSavings;
    var isAnyNan = isNaN(commissionWithPortal) || isNaN(commissionWithPortal) || isNaN(restaurantSavings);
    return (React.createElement("div", { className: "savings-calculator ".concat(className) },
        React.createElement("h4", null, "wprowadzaj\u0105c zam\u00F3wienia online na w\u0142asnej stronie www dla restauracji"),
        React.createElement("div", { className: "row mx-0 mt-3 justify-content-between w-100" },
            React.createElement("div", { className: "calculator-variable col" },
                React.createElement(Label, { name: "portalCommissionPercent" }, "Prowizja na portalu"),
                React.createElement(Input, { name: "portalCommissionPercent", value: values.portalCommissionPercent, onChange: handleChange, type: "select" }, portalPercents.map(function (p) { return React.createElement("option", { key: p, value: p },
                    p,
                    "%"); }))),
            React.createElement("div", { className: "calculator-variable col" },
                React.createElement(Label, { name: "ordersMonthlyAmount" }, "Liczba zam\u00F3wie\u0144"),
                React.createElement(Input, { name: "ordersMonthlyAmount", value: values.ordersMonthlyAmount, onChange: handleChange, type: "select" }, orderAmountOptions.map(function (p) { return React.createElement("option", { key: p, value: p },
                    p,
                    " zam\u00F3wie\u0144 w miesi\u0105cu"); }))),
            React.createElement("div", { className: "calculator-variable col" },
                React.createElement(Label, { name: "avgOrderValue" }, "Warto\u015B\u0107 zam\u00F3wienia"),
                React.createElement(Input, { name: "avgOrderValue", value: values.avgOrderValue, onChange: handleChange, type: "select" }, orderAvgPrices.map(function (p) { return React.createElement("option", { key: p, value: p },
                    p,
                    " z\u0142"); }))),
            React.createElement("div", { className: "col mt-3 mt-md-0 col-xs-12 col-md-auto calculator-savings" },
                React.createElement("div", { className: "col p-0" },
                    React.createElement("h5", { className: "savings-item__title" }, "Prowizja"),
                    React.createElement("div", { className: "row flex-nowrap justify-content-center" },
                        React.createElement("div", { className: "text-danger savings-item__number savings-item__number--crossed" },
                            isAnyNan ? '-' : commissionWithPortal,
                            " ",
                            currency),
                        React.createElement("span", { className: "savings-item__number mx-1" }, "->"),
                        React.createElement("div", { className: "text-success savings-item__number" },
                            isAnyNan ? '-' : commissionWithOwnWebsite,
                            " ",
                            currency))),
                React.createElement("div", { className: "col" },
                    React.createElement("h5", { className: "savings-item__title" }, "Zaoszcz\u0119dzasz"),
                    React.createElement("div", { className: "savings-item__number savings-item__number--main" },
                        isAnyNan ? '-' : restaurantSavings,
                        " ",
                        currency))))));
};
var otostolikCommissionPercent = 5;
var onlinePaymentsCommissionPercent = 1.5;
export function calculateSavingsWithCommission(input) {
    var portalCommissionPercent = input.portalCommissionPercent, _a = input.onlinePaidOrdersPercent, onlinePaidOrdersPercent = _a === void 0 ? 50 : _a, ordersMonthlyAmount = input.ordersMonthlyAmount, avgOrderValue = input.avgOrderValue;
    var commissionWithPortal = fixDecimal((ordersMonthlyAmount * avgOrderValue * portalCommissionPercent) / 100);
    var onlinePaidOrdersAmount = Math.ceil(ordersMonthlyAmount * onlinePaidOrdersPercent / 100);
    var ordersCommission = fixDecimal((ordersMonthlyAmount * avgOrderValue * otostolikCommissionPercent) / 100);
    var onlinePaymentsCommission = fixDecimal((onlinePaidOrdersAmount * avgOrderValue * onlinePaymentsCommissionPercent) / 100);
    var commissionWithOwnWebsite = fixDecimal(ordersCommission + onlinePaymentsCommission);
    var restaurantSavings = fixDecimal(commissionWithPortal - commissionWithOwnWebsite);
    return {
        commissionWithPortal: commissionWithPortal,
        commissionWithOwnWebsite: commissionWithOwnWebsite,
        ordersCommission: ordersCommission,
        onlinePaymentsCommission: onlinePaymentsCommission,
        restaurantSavings: restaurantSavings,
    };
}
export default SavingsCalculator;
